/*
Oil Finishes
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Oil Finishes'
const id = 'J54xVduQzdnyIa9EJ7OR'

export default {
  name,
  id,
  filters,
  headers,
  form
}
